import React from "react";
import { Box, Typography, Avatar, Button, List, ListItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import { AccountBalanceWallet, Redeem, ListAlt, Code, LocalOffer, Feedback, Language, Settings } from "@mui/icons-material";

const Profile = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#000",
        color: "#fff",
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      {/* User Information */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Avatar
          sx={{
            width: "80px",
            height: "80px",
            margin: "0 auto",
            marginBottom: "8px",
          }}
          src="https://via.placeholder.com/80"
          alt="User Avatar"
        />
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
          Guest
        </Typography>
        <Typography variant="body2" sx={{ color: "#aaa", mb: 2 }}>
          UID: 288490869
        </Typography>
        <Button
          variant="outlined"
          sx={{
            color: "#fff",
            borderColor: "#fff",
            borderRadius: "24px",
            padding: "8px 24px",
          }}
        >
          Sign In
        </Button>
      </Box>

      {/* Wallet Section */}
      <Box
        sx={{
          backgroundColor: "#1a1a1a",
          borderRadius: "12px",
          padding: "16px",
          mb: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            My Wallet
          </Typography>
          <Typography variant="body2" sx={{ color: "#aaa" }}>
            Detail
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "16px",
          }}
        >
          <Box>
            <Typography variant="h4" sx={{ fontWeight: "bold", color: "#f50057" }}>
              0
            </Typography>
            <Typography variant="body2" sx={{ color: "#aaa" }}>
              Balance
            </Typography>
          </Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#f50057",
              color: "#fff",
              borderRadius: "24px",
              padding: "8px 24px",
            }}
          >
            Refill
          </Button>
        </Box>
      </Box>

      {/* Menu Options */}
      <List>
        {/* Earn Rewards */}
        <ListItem
          button
          sx={{
            color: "#fff",
          }}
        >
          <ListItemIcon>
            <Redeem sx={{ color: "#f50057" }} />
          </ListItemIcon>
          <ListItemText primary="Earn Rewards" />
        </ListItem>
        <Divider sx={{ backgroundColor: "#333" }} />

        {/* My List */}
        <ListItem
          button
          sx={{
            color: "#fff",
          }}
        >
          <ListItemIcon>
            <ListAlt sx={{ color: "#f50057" }} />
          </ListItemIcon>
          <ListItemText primary="My List" />
        </ListItem>
        <Divider sx={{ backgroundColor: "#333" }} />

        {/* Invitation Code */}
        <ListItem
          button
          sx={{
            color: "#fff",
          }}
        >
          <ListItemIcon>
            <Code sx={{ color: "#f50057" }} />
          </ListItemIcon>
          <ListItemText primary="Invitation Code" />
        </ListItem>
        <Divider sx={{ backgroundColor: "#333" }} />

        {/* My Coupons */}
        <ListItem
          button
          sx={{
            color: "#fff",
          }}
        >
          <ListItemIcon>
            <LocalOffer sx={{ color: "#f50057" }} />
          </ListItemIcon>
          <ListItemText primary="My Coupons" />
        </ListItem>
        <Divider sx={{ backgroundColor: "#333" }} />

        {/* Feedback */}
        <ListItem
          button
          sx={{
            color: "#fff",
          }}
        >
          <ListItemIcon>
            <Feedback sx={{ color: "#f50057" }} />
          </ListItemIcon>
          <ListItemText primary="Feedback" />
        </ListItem>
        <Divider sx={{ backgroundColor: "#333" }} />

        {/* Language */}
        <ListItem
          button
          sx={{
            color: "#fff",
          }}
        >
          <ListItemIcon>
            <Language sx={{ color: "#f50057" }} />
          </ListItemIcon>
          <ListItemText primary="Language" />
        </ListItem>
        <Divider sx={{ backgroundColor: "#333" }} />

        {/* Settings */}
        <ListItem
          button
          sx={{
            color: "#fff",
          }}
        >
          <ListItemIcon>
            <Settings sx={{ color: "#f50057" }} />
          </ListItemIcon>
          <ListItemText primary="Setting" />
        </ListItem>
      </List>
    </Box>
  );
};

export default Profile;